import { FlexWrapper, GapView, ParentDiv } from '../../styles/WrapperStyles'
import { React, useState, useRef, useEffect } from 'react'
import { styled, css } from 'styled-components'
import urls from "../../api/urls.json";
import Loader from "../Loader";
import StoryListModal from '../modals/StoryListModal';
import { ImageDivFeed } from '../../styles/ImageWrapper';
import placeholder_image from '../../assests/placeholder_image.png';
import { CommonTextStyleSpan } from '../../styles/TextStyles';
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import { authorizedHttpGet } from '../../api/httpCalls';
import PageModal from "../modals/PageModal";
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import EmptyView from '../EmptyView';
import '../styles/Stories.css';

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;
    margin-left: 200px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const NameWrapper = styled.div`
  margin-left: 20px;
  ${props =>
        props.width &&
        css`
      width: ${props.width};
    `}
`;

const ProfileItemWrapper = styled(FlexWrapper)`
  margin-top: 15px;
`;


const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;

const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;


function Stories() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const handleLeftNavAppChange = (name) => {
        setAppName(name)
    };


    const [apiPageChange, setApiPageChange] = useState(1);
    const [isLoading, setIsLoading] = useState(false)
    const totalPagesApi = useRef(0);
    const [displayStoryListmodal, setStoryModal] = useState(false);
    const [storyList, setStoryList] = useState([])
    const [togglePageModal, setTogglePageModal] = useState(false);
    const [selectedStory, setSelectedStory] = useState("All")
    const [dropDownOptions, setDropDownOptions] = useState([])
    const [params, setParams] = useState({
        page: apiPageChange,
        has_note: 0,
        reason_id: null
    })

    const closeModal = () => {
        setStoryModal(false)
    }

    const getStories = async () => {
        setIsLoading(true)
        params['page'] = apiPageChange
        let response = await authorizedHttpGet(urls.GET_STORIES, params)
        if (response.status) {
            setDropDownOptions(response.data.reason_list)
            setStoryList(response.data.story_list)
            totalPagesApi.current = response.data.total_pages
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getStories()
    }, [apiPageChange, appName, params])

    useEffect(() => {
        setSelectedStory("All")
        setApiPageChange(1)
    }, [appName])

    const updateStory = (item) => {
        setParams({
            page: apiPageChange,
            has_note: item.has_note,
            reason_id: item.reason_id
        })
        setSelectedStory(item.story)
        closeModal()
    }

    const goToPage = (pageModalNumber) => {
        setTogglePageModal(false);
        if (pageModalNumber > totalPagesApi.current) {
            alert("Page number is greater than total pages");
        } else {
            setApiPageChange(pageModalNumber);
        }
    }

    return (
        <div className='App'>
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Stories'} />
            {isLoading && <Loader />}
            {togglePageModal && <PageModal goToPage={goToPage} page={apiPageChange} closeModal={() => setTogglePageModal(false)} />}
            {displayStoryListmodal && <StoryListModal closeModal={closeModal} updateStory={updateStory} appName={appName} dropDownOptions={dropDownOptions} />}
            <ParentDiv className='marginLeft200'>
                <FlexWrapper className='marginTop25'>
                    <HeaderWrapper className='cursorPointer' onClick={() => setTogglePageModal(true)}>
                        <HeaderSelected>{apiPageChange}</HeaderSelected>
                        <HeaderSelected className='marginLeft10'>{totalPagesApi.current}</HeaderSelected>
                    </HeaderWrapper>
                    <HeaderWrapper>
                        <HeaderTextView selected={true} marginRight cursor onClick={() => setStoryModal(true)}>{selectedStory}</HeaderTextView>
                    </ HeaderWrapper>
                </FlexWrapper>
                <GapView height="40px" />



                {storyList.map((profile, pos) => {
                    return (
                        <ProfileItemWrapper key={profile.ref}>
                            <ImageDivFeed
                                rectangle={false}
                                src={profile.avatar}
                                onError={e => {
                                    e.target.src = placeholder_image;
                                }}
                            />
                            <NameWrapper width="350px">
                                <CommonTextStyleSpan highlight>
                                    {profile.name}, {profile.gender[0]}, {profile.age}{' '}
                                </CommonTextStyleSpan>
                                <CommonTextStyleSpan>{profile.ref}</CommonTextStyleSpan>
                                <br />
                                <br />
                                <br />
                                <CommonTextStyleSpan>
                                    {profile.deletion_date} / {profile.deletion_time} <br />
                                    {profile.personal_email}
                                    <br />
                                    {profile.mobile_number}
                                </CommonTextStyleSpan>
                            </NameWrapper>
                            <NameWrapper width="370px">
                                <CommonTextStyleSpan grey>{profile.reason}</CommonTextStyleSpan>
                                <br />
                                <br />
                                <br />
                                <CommonTextStyleSpan grey>{profile.note}</CommonTextStyleSpan>
                            </NameWrapper>
                        </ProfileItemWrapper>
                    );
                })}
                {
                    storyList.length > 0 &&
                    <BottomBarWrapper className='marginTop30 marginBottom30' >
                        {parseInt(apiPageChange) === 1 ? <img className='marginRight20' src={previous_inctive} /> : <img className='marginRight20' src={previous_active} onClick={() => setApiPageChange(parseInt(apiPageChange) - 1)} />}
                        {parseInt(apiPageChange) === totalPagesApi.current ? <img src={next_inactive} /> : <img src={next_active} onClick={() => setApiPageChange(parseInt(apiPageChange) + 1)} />}
                    </BottomBarWrapper>
                }

                {
                    storyList.length == 0 &&
                    <EmptyView />
                }

            </ParentDiv >

        </div>
    );
}

export default Stories;